import { createSlice } from '@reduxjs/toolkit'
import { combineReducers } from 'core/redux'
import merge from 'deepmerge'

import { UPDATE_COMPONENT_STATE } from './types'

const defaultInstance = {}

const byIdSlice = createSlice({
  name: 'reports/components/withComponentState',
  initialState: defaultInstance,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      UPDATE_COMPONENT_STATE,
      (draftState, { payload: { componentId, componentState } = {} }) => {
        draftState[componentId] = merge(
          draftState[componentId] || {},
          componentState || {}
        )
      }
    )
  },
})

export default combineReducers({
  byId: byIdSlice.reducer,
})
